import React from "react";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";

export default function ProductLoader({
  cardImg,
  has_variants = false,
  height = "245px",
}) {
  const [isLoading, setIsLoading] = useState(true);
  const ensureProtocol = (url) => {
    return url?.startsWith("http://") || url?.startsWith("https://")
      ? url
      : `${process.env.REACT_APP_IMAGE_Link}${url}`;
  };
  return (
    <>
      {isLoading ? <Skeleton count={1} height={height} /> : null}

      <img
        className="img-fluid"
        src={!has_variants ? (cardImg ? ensureProtocol(cardImg) : "") : cardImg}
        alt="product"
        style={isLoading ? { display: "none" } : {}}
        onLoad={() => {
          setIsLoading(false);
        }}
      />
    </>
  );
}
